import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    marginTop: '5px',
  },
})(props => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const useStyles = makeStyles({
  reviewImage: {
    maxWidth: '24px',
    maxHeight: '24px',
  },
});


export default function MessageButtonMulti(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="outlined"
        size="large"
        color="primary"
        onClick={handleClick}
      >
        {props.buttonText}
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {Object.entries(props.multiLinks).filter( item =>
          item[1].link && item[1].show
        ).map( (item, i) =>
          <MenuItem component='a' onClick={handleClose} key={i}
            target="_blank" rel="noopener" href={item[1].link}
          >
            <ListItemIcon>
              <img className={classes.reviewImage} src={process.env.STATIC_URL + item[1].imagePath} />
            </ListItemIcon>
            <ListItemText primary={item[0]} />
          </MenuItem>
        )}
      </StyledMenu>
    </div>
  );
}
